// PUTs a file to a presigned URL via XHR — fetch cannot report upload
// progress, and installers are large enough that the user needs one.
// contentType must match the value baked into the presign signature or S3
// rejects the PUT.
export function uploadFileWithProgress(
  uploadUrl: string,
  file: File,
  contentType: string,
  onProgress: (fraction: number) => void
): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open("PUT", uploadUrl)
    xhr.setRequestHeader("Content-Type", contentType)
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) onProgress(e.loaded / e.total)
    }
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) resolve()
      else reject(new Error(`Upload failed (HTTP ${xhr.status})`))
    }
    xhr.onerror = () => reject(new Error("Upload failed (network error)"))
    xhr.ontimeout = () => reject(new Error("Upload failed (timed out)"))
    xhr.send(file)
  })
}
